// export default {
//   name: "Maintenance New",
//   meta: {
//     icon: "build",
//     expanded: true,
//     auth: true
//   },
//   departmentName: "Maintanence",
//   finalPagePermision: "",
//   children: [
//     {
//       name: "Maintenance Details",
//       permissionName: 'Maintenance Details',
//       keywords: ['Maintenance Details'],
//       path: "/MaintDashboard/maintDashboard",
//       meta: {
//           auth: true
//       },
//       component: require("../component/maintenance/MaintDashboard/maintDashboard.vue"),
//       finalPagePermision: "Maintenance Details",
//     },
//     {
//       name: "PO Order Details",
//       permissionName: 'PO Order Details',
//       keywords: ['PO Order Details'],
//       path: "/poOrder/viewPoOrder",
//       meta: {
//           auth: true
//       },
//       component: require("../component/maintenance/poOrder/viewPoOrder.vue"),
//       finalPagePermision: "PO Order Details",
//     },
//     {
//       name: "Stock-In Details",
//       permissionName: 'Stock-In Details',
//       keywords: ['Stock-In Details'],
//       path: "/viewStockIn",
//       meta: {
//           auth: true
//       },
//       component: require("../component/maintenance/stockIn/viewStockIn.vue"),
//       finalPagePermision: "Stock-In Details",
//     },
//     {
//       name: "Service Estimation Details",
//       permissionName: 'Service Estimation Details',
//       keywords: ['Service Estimation Details'],
//       path: "/serviceEstimation/viewServiceEstimation",
//       meta: {
//           auth: true
//       },
//       component: require("../component/maintenance/serviceEstimation/viewServiceEstimation.vue"),
//       finalPagePermision: "Service Estimation Details",
//     },
//     {
//       name: "Job-Order Details",
//       permissionName: 'Job-Order Details',
//       keywords: ['Job-Order Details'],
//       path: "/jobOrderSheet/viewJobOrder",
//       meta: {
//           auth: true
//       },
//       component: require("../component/maintenance/jobOrderSheet/viewJobOrder.vue"),
//       finalPagePermision: "Job-Order Details",
//     },
//     {
//       name: "Vehicle Service History",
//       permissionName: 'Vehicle Service History',
//       keywords: ['Vehicle Service History'],
//       path: "/vehicleServiceHistory/vehicleServiceHistory",
//       meta: {
//           auth: true
//       },
//       component: require("../component/maintenance/vehicleServiceHistory/vehicleServiceHistory.vue"),
//       finalPagePermision: "Item Master",
//     },
//     {
//       name: "Item Master",
//       permissionName: 'Item Master',
//       keywords: ['Item Master'],
//       path: "/itemMaster/itemMaster",
//       meta: {
//         auth: true
//       },
//       component: require("../component/maintenance/itemMaster/itemMaster.vue"),
//       finalPagePermision: "Item Master",
//     },
//     {
//       name: "Request For Quotation",
//       permissionName: 'Request For Quotation',
//       keywords: ['Request For Quotation'],
//       path: "/ResOfQuo/ResOfQuo",
//       meta: {
//           auth: true
//       },
//       component: require("../component/maintenance/ResOfQuo/ResOfQuo.vue"),
//       finalPagePermision: "Request For Quotation",
//     },
//     {
//       name: "Response Of Quotation",
//       permissionName: 'Response of Quotation',
//       keywords: ['Response of Quotation'],
//       path: "/responseOfQuo/responseOfQuo",
//       meta: {
//           auth: true
//       },
//       component: require("../component/maintenance/quotationOfResponse/viewResponse.vue"),
//       finalPagePermision: "Response of Quotation",
//     },
//     {
//       name: "PO Vendor Master",
//       permissionName: 'Vendor Master',
//       keywords: ['Vendor Master'],
//       path: "/povendorMaster",
//       meta: {
//           auth: true
//       },
//       component: require("../component/masters/vendorMaster.vue"),
//       finalPagePermision: "Vendor Master",
//   },
//   {
//       name: "PO Vendor GST Master",
//       permissionName: 'Vendor GST Master',
//       keywords: ['Vendor Master'],
//       path: "/povendorgstMaster",
//       meta: {
//           auth: true
//       },
//       component: require("../component/masters/vendorGstMaster.vue"),
//       finalPagePermision: "Vendor Master",
      
//   },
//   ]
// };


// WEBPACK FOOTER //
// ./src/sidebar/maintenanceNew.js